import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources organized by language
const resources = {
  en: {
    translation: {
      // Header
      login: 'Log In',
      signin: 'Sign Up',
      language: 'Language',
      
      // Home Page
      searchPlaceholder: 'Search for services...',
      popularCategories: 'Popular Categories',
      viewAll: 'View All',
      
      // Navigation
      home: 'Home',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      
      // Footer
      copyright: '© 2023 Your Company. All rights reserved.',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy'
    }
  },
  es: {
    translation: {
      login: 'Iniciar sesión',
      signin: 'Registrarse',
      language: 'Idioma',
      searchPlaceholder: 'Buscar servicios...',
      popularCategories: 'Categorías populares',
      viewAll: 'Ver todos',
      home: 'Inicio',
      services: 'Servicios',
      about: 'Nosotros',
      contact: 'Contacto',
      copyright: '© 2023 Tu empresa. Todos los derechos reservados.',
      terms: 'Términos de servicio',
      privacy: 'Política de privacidad'
    }
  },
  // Add more languages as needed
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en', // Remember user preference
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;